import { useCallback, useMemo } from 'react';

import { useGrid } from '@Components/Grid';

import { useDataExtractorStore } from '../../store';

export default function useEvents() {
  const { store: { collections: { setItems }, downloadFile, deleteFile, refresh }, handleRefresh } = useGrid()
  const { cancelProcess, retryProcess } = useDataExtractorStore()

  const handleDownload = useCallback(async row => {
    const data = await downloadFile(row.id)
    const href = URL.createObjectURL(data)

    const link = document.createElement('a')
    link.href = href
    link.setAttribute('download', `${row.dataType}-${row.id}.zip`)
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link)
    URL.revokeObjectURL(href)
  }, [downloadFile])

  const handleDelete = useCallback(async jobId => {
    await deleteFile(jobId)
    handleRefresh()
  }, [deleteFile, handleRefresh])

  const handleCancel = useCallback(async id => {
    await cancelProcess(id)
    handleRefresh()
  }, [cancelProcess, handleRefresh])

  const handleRetry = useCallback(async id => {
    await retryProcess(id)
    handleRefresh()
  }, [retryProcess, handleRefresh])

  const handleAutoRefresh = useCallback(async id => {
    const updatedItem = await refresh(id)
    setItems(items => items.map(item => {
      if (item.id === id) return { ...item, ...updatedItem }
      return item
    }))
  }, [refresh, setItems])

  return useMemo(() => ({
    handleRetry,
    handleDownload,
    handleDelete,
    handleCancel,
    handleAutoRefresh,
  }), [handleDownload, handleDelete, handleCancel, handleRetry, handleAutoRefresh])
}
